import React from 'react';
import type { JSX, PropsWithChildren } from 'react';
import ReactPlaceholder from 'react-placeholder';
import styled from '@emotion/styled';
import type { WidthProps } from 'styled-system';
import { width } from 'styled-system';

interface SkeletonLoaderProps extends PropsWithChildren {
  placeholder: JSX.Element;
  /** Flag indicating whether content is ready or loading */
  ready: boolean;
}

// Those are styles copied from 'react-placeholder/lib/reactPlaceholder.css'
// We inject them directly into the ReactPlaceholder component.
// Importing .css file causes performance issue with next.js, as it's being
// extracted to separate stylesheet (which delays initial load and rendering).
// In Corgi it's handled by custom Webpack config (see "with-lazy-styles.js"),
// but that would be an overkill to copy this to next.js webpack configuration.
const Placeholder = styled(ReactPlaceholder)<WidthProps>`
  ${width};

  .show-loading-animation.rect-shape,
  .show-loading-animation.round-shape,
  .show-loading-animation.text-row,
  .show-loading-animation .rect-shape,
  .show-loading-animation .round-shape,
  .show-loading-animation .text-row {
    animation: react-placeholder-pulse 1.5s infinite;
  }

  @keyframes react-placeholder-pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

const SkeletonLoader = ({ children, placeholder, ready }: SkeletonLoaderProps) => (
  <Placeholder width={1} ready={ready} customPlaceholder={placeholder}>
    {children}
  </Placeholder>
);

export default SkeletonLoader;
